var _defs, _circle, _path, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAaveCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Aave") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaveGrad",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B6509E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EBAC6"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#aaveGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8,10.2 C4.8,6.3 6.1,4.3 8,4.3 C9.9,4.3 11.2,6.3 11.2,10.2 L11.2,11.2 L10.2,10.2 L9.2,11.2 L8,10.2 L6.8,11.2 L5.8,10.2 L4.8,11.2 Z",
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.6,
    cy: 8,
    r: 0.55,
    fill: "#2B2B2B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 8,
    r: 0.55,
    fill: "#2B2B2B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaveCircle);
export default __webpack_public_path__ + "static/media/aave-circle.65d51eedc31da096e09fa8646ee00d08.svg";
export { ForwardRef as ReactComponent };